module.exports = '/ng-templates/login/kp-login/login-systems/ldap/ldap.login-system.tpl.ftl';
